export default __webpack_public_path__ + "img/Inter-SemiBoldItalic_6880080.woff2";